import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Logo = () => (
  <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
    <div style={{ width: 36, height: 36, background: '#00d55b', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    </div>
    <div>
      <div style={{ fontSize: 18, fontWeight: 700, color: '#fff', lineHeight: 1 }}>
        <span style={{ color: '#00d55b' }}>MS</span>Chat
      </div>
      <div style={{ fontSize: 9, color: '#555', letterSpacing: '0.08em', textTransform: 'uppercase' }}>by MS Discoveries</div>
    </div>
  </Link>
);

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const loc = useLocation();
  const links = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About' },
    { to: '/plans', label: 'Plans' },
    { to: '/contact', label: 'Contact' }
  ];

  return (
    <nav style={{ background: 'rgba(0,0,0,0.97)', borderBottom: '1px solid #1e1e1e', position: 'sticky', top: 0, zIndex: 100, backdropFilter: 'blur(12px)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 20px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Logo />

        {/* Desktop links */}
        <div className="nav-links" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {links.map(l => (
            <Link key={l.to} to={l.to} style={{ padding: '6px 14px', borderRadius: 6, fontSize: 14, fontWeight: 500, color: loc.pathname === l.to ? '#00d55b' : '#888', background: loc.pathname === l.to ? 'rgba(0,213,91,0.1)' : 'transparent', transition: 'all 0.2s' }}>
              {l.label}
            </Link>
          ))}
        </div>

        {/* Desktop CTA */}
        <div className="nav-links" style={{ display: 'flex', gap: 8 }}>
          <Link to="/login" style={{ padding: '8px 16px', border: '1px solid #1e1e1e', borderRadius: 8, color: '#fff', fontSize: 14, fontWeight: 500, background: 'transparent' }}>Login</Link>
          <Link to="/register" style={{ padding: '8px 16px', background: '#00d55b', borderRadius: 8, color: '#000', fontSize: 14, fontWeight: 700 }}>Get Started</Link>
        </div>

        {/* Mobile menu button */}
        <button className="mobile-menu-btn" onClick={() => setMobileOpen(!mobileOpen)}
          style={{ display: 'none', background: 'none', border: 'none', color: '#fff', fontSize: 22, cursor: 'pointer', padding: 4 }}>
          {mobileOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div style={{ background: '#0d0d0d', borderTop: '1px solid #1e1e1e', padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 4 }}>
          {links.map(l => (
            <Link key={l.to} to={l.to} onClick={() => setMobileOpen(false)}
              style={{ padding: '12px 14px', borderRadius: 8, fontSize: 15, fontWeight: 500, color: loc.pathname === l.to ? '#00d55b' : '#888', background: loc.pathname === l.to ? 'rgba(0,213,91,0.1)' : 'transparent' }}>
              {l.label}
            </Link>
          ))}
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <Link to="/login" onClick={() => setMobileOpen(false)} style={{ flex: 1, padding: '10px', border: '1px solid #1e1e1e', borderRadius: 8, color: '#fff', fontSize: 14, textAlign: 'center', fontWeight: 500 }}>Login</Link>
            <Link to="/register" onClick={() => setMobileOpen(false)} style={{ flex: 1, padding: '10px', background: '#00d55b', borderRadius: 8, color: '#000', fontSize: 14, textAlign: 'center', fontWeight: 700 }}>Get Started</Link>
          </div>
        </div>
      )}
    </nav>
  );
}

export { Logo };
